// extracted by mini-css-extract-plugin
export default {"removeButton":"removeButton--jAoaA","removeIcon":"removeIcon--hKV10","error":"error--Qys_m"};